<div class="am-modal-internal">
    <div class="am-space"></div>
    <div class="am-close-div bg-am-medium-blue am-close-x">
        <button type="button" class=" text-am-white am-modal-close" (click)="closeModal('close')">
            <img src="../../../../assets/images/close.svg" alt="close">
        </button>
        </div>
    <div class="am-img-alert">
        <img alt="" class="am-img-alert-img" src="../../../../assets/images/alert/warningAlert.svg" />
    </div>
    <div class="modal-title">
        <p>{{  'iropsDeleteCHKModal.tittle' | translate }}</p>
    </div>
    <div class="modal-subtitle txt-Garnett-Regular-24">
        <p>{{  'iropsDeleteCHKModal.subtittle' | translate }}</p>
    </div>
    <div>
        <button class="btn-continue txt-Garnett-Regular-18" (click)="onContinue()">{{  'iropsDeleteCHKModal.button' | translate }}</button>
    </div>
</div>
